import { Flex } from "@chakra-ui/layout";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import ConsultantImage from "../components/ConsultantImage";
import LoadingIndicator from "../components/Loading";
import { Back } from "../components/button/Back";
import { ConsultantCompetencePills } from "../components/competence-pill/ConsultantCompetencePill";
import { LoggedInLayout } from "../components/layouts/LoggedInLayout";
import { PageTitle } from "../components/text/PageTitle";
import { useConsultantAccount } from "@api/hooks";
import { appTheme } from "@styles/Theme";

const ConsultantProfilePage = () => {
	const params = useParams();
	const userId = params.id as string;

	// API hooks to fetch data
	const { consultantAccount, isLoading, isError } = useConsultantAccount(userId);

	return (
		<LoggedInLayout>
			<Styles>
				{consultantAccount ? (
					<>
						<PageTitle>Konsultprofil</PageTitle>
						<Back />
					</>
				) : isLoading ? (
					<LoadingIndicator />
				) : (
					isError && (
						<p>
							Kunde ej läsa in konsultprofil, detta kan beror på att användaren har tagits bort eller ett tekniskt fel.
						</p>
					)
				)}

				{consultantAccount && (
					<>
						<Flex gap={3} direction={["column", "column", "row", "row"]} align={"center"}>
							<ConsultantImage
								url={consultantAccount.profile.profilePicture}
								name={consultantAccount.firstName + " " + consultantAccount.lastName}
								size="190px"
								placeholderFontSize="3xl"
							/>

							<Flex
								direction={"column"}
								ml={"30px"}
								gap={"12px"}
								align={["center", "center", "flex-start", "flex-start"]}
							>
								<h2>
									{consultantAccount.firstName || ""} {consultantAccount.lastName || ""}
								</h2>

								{consultantAccount.profile.competences && (
									<ConsultantCompetencePills competences={consultantAccount.profile.competences} />
								)}
							</Flex>
						</Flex>

						<p className={!consultantAccount.profile?.presentation ? "missing-presentation" : ""}>
							{consultantAccount.profile?.presentation || "Presentation saknas"}
						</p>
					</>
				)}
			</Styles>
		</LoggedInLayout>
	);
};

export default ConsultantProfilePage;

const Styles = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1.5rem;
	padding-bottom: 400px;

	p {
		margin: 0.75rem 0 0 0;
	}

	p.missing-presentation {
		color: ${(props) => props.theme.colors.textDimmed};
	}

	h2 {
		font-style: normal;
		font-weight: 600;
		font-size: 24px;
		line-height: 29px;
		color: ${appTheme.colors.darker};
	}
`;
